import { GameEvents } from '../../GameEvents';
import { CharacterAttack } from '../attacks/CharacterAttack';
import { CharacterAttackCharge } from '../attacks/CharacterAttackCharge';
import { CharacterBase } from '../CharacterBase';
import { CharacterEnemy } from '../CharacterEnemy';
import { CharacterStateMachineEnemy } from '../statemachines/CharacterStateMachine';

const IDLE_TIME = 3;

const CONFIG = {
  id: 'sheriff',
  spineid: 'sheriff',
  combatStyle: 'RANGED',
  speed: 300,
  health: 400,
  coins: 10,
  stagger: false,
  knockdown: false,
  attackRate: 3.5,
  attackRange: 400,
  attacks: [],
};
const ATTACKS = {
  movingshot: {
    id: 'moving_shot',
    name: 'moving_shot',
    animation: 'moving_shot',
    damage: 10,
  },
  sprayshot: {
    id: 'static_spray',
    name: 'static_spray',
    animation: 'static_spray',
    damage: 10,
  },
  charge: {
    id: 'charge',
    name: 'charge',
    animation: 'charge',
    damage: 50,
    knockdown: true,
  },
};

export class CharacterSheriff extends CharacterEnemy {
  constructor(scene, x, y, config, collisionmap) {
    super(scene, x, y, CONFIG, collisionmap);
    this._grabbable = false;
    this._attackCounter = 0;
    this.attackMovingShot = new CharacterAttack(scene, this, ATTACKS.movingshot);
    this.attackSprayshot = new CharacterAttack(scene, this, ATTACKS.sprayshot);
    this.attackCharge = new CharacterAttackCharge(scene, this, ATTACKS.charge);
    this.attackQueued = false;
    this.idleTime = 0;
    this.movingShotCooldown = 2;
    this.isBoss = true;
  }

  createStateMachine() {
    return new CharacterSheriffStateMachine(this.scene, this);
  }

  chooseAttack() {
    if (this.attackQueued) return;
    this._attackCounter++;
    if (this._attackCounter % 3 === 0) {
      this.attackQueued = this.attackCharge;
    } else {
      this.attackQueued = this.attackSprayshot;
    }
  }

  activateAttack(attack) {
    if (attack.name === 'moving_shot') {
      this._attackActive = attack;
      this._attackActive.trigger();
      this.setState(CharacterBase.STATES.ATTACK);
    } else {
      super.activateAttack(attack);
    }
    if (attack === this.attackQueued) this.attackQueued = null;
  }

  findPathToHero() {}

  handleAttackEvent() {
    switch (this.activeAttack.name) {
      case 'moving_shot':
        this.scene.events.emit(GameEvents.SPAWN_PROJECTILE, {
          sprite: 'projectile_sheriffbullet',
          damage: 20,
          x: this.x + 100 * this.faceDirection,
          y: this.y - 150,
          depth: this.y,
          velocity: { x: 1500 * this.faceDirection, y: 0 },
        });
        break;
      case 'static_spray':
        this.scene.events.emit(GameEvents.SPAWN_PROJECTILE, {
          sprite: 'projectile_sheriffbullet',
          damage: 20,
          x: this.x + 100 * this.faceDirection,
          y: this.y - 150,
          depth: this.y,
          velocity: { x: 1500 * this.faceDirection, y: Math.random() * 600 - 300 },
        });
        break;
    }
  }

  checkForMovingShot(delta) {
    if (this.movingShotCooldown <= 0) {
      return (
        (this.x > this.scene.viewport.centerX && this.faceDirection == -1) ||
        (this.x < this.scene.viewport.centerX && this.faceDirection == 1)
      );
    } else {
      this.movingShotCooldown -= delta;
    }
  }

  triggerMovingShot() {
    this.movingShotCooldown = 1;
    this.activateAttack(this.attackMovingShot);
  }

  handleAttackComplete() {
    const attack = this._attackActive;
    this.movingShotCooldown = 1;
    this.attackQueued = null;
    super.handleAttackComplete();
    if (attack.name != 'moving_shot') {
      this.setState('switchSide');
    }
  }
}

class CharacterSheriffStateMachine extends CharacterStateMachineEnemy {
  idle(delta) {
    if (!this.character.path?.length) {
      this.character.playAnimation(CharacterBase.ANIMATIONS.IDLE, true);
      this.character.faceTarget(this.character.heroTarget);
    } else {
      this.character.playAnimation(CharacterBase.ANIMATIONS.WALK, true);
      this.character.faceDirection = this.character.velocity.x > 0 ? 1 : -1;
    }
    this.character.updateMovement(delta);
    this._checkIdle(delta);
  }
  attack(delta) {
    if (this.character.activeAttack?.name === 'moving_shot') {
      this.character.updatePath(delta);
    }
    super.attack(delta);
  }
  switchSide() {
    this.character.findPath(this.character, {
      x:
        this.character.x > this.scene.viewport.centerX
          ? this.scene.viewport.x + 150
          : this.scene.viewport.x + this.scene.viewport.width - 150,
      y: this.character.heroTarget?.y || this.character.y,
    });
    this.character.setIdleState();
  }

  _checkIdle(delta) {
    this.character.checkForRequestAttack(delta);
    if (!this.character.path?.length && !this.character._pathSearching) {
      this.character.faceTarget(this.character.heroTarget);
      if (this.character.attackQueued) {
        this.character.idleTime = IDLE_TIME;
        this.character.activateAttack(this.character.attackQueued);
      } else {
        this.character.idleTime -= delta;
        if (this.character.idleTime < 0) {
          this.character.idleTime = IDLE_TIME;
          this.character.setState('switchSide');
        }
      }
    } else if (this.character.checkForMovingShot(delta)) {
      this.character.triggerMovingShot();
    }
  }
}
